import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  travelerInfo: {}
};

export default function travelerEdit(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取出行人详情
    case ACTION_TYPES.GET_TRAVELER_EDIT_DETAIL:
      result.travelerInfo = payload;
      break;
    default:
      result = state;
  }
  return result;
}
